import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

export const AppCustomConfirmationDialog = ({
    open,
    onClose,
    onAccept,
    onDecline,
    title,
    bodyMessage,
    acceptButtonText = "Confirmer",
    declineButtonText = "Annuler",
    acceptButtonColor = "error"
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {bodyMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onDecline} color="primary">
                    {declineButtonText}
                </Button>
                <Button onClick={onAccept} color={acceptButtonColor} autoFocus>
                    {acceptButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
